import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];

/** @jsx jsx */
import { colors } from '@flowio/react-theme';
import { css, jsx } from '@emotion/react';
import { DialogBody } from '@flowio/react-dialog';
import React from 'react';

var WorksheetBody = function WorksheetBody(_ref) {
  var children = _ref.children,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return jsx(DialogBody, _extends({}, unhandledProps, {
    css: /*#__PURE__*/css({
      backgroundColor: colors.WHITE,
      padding: '1.5rem 1rem'
    }, process.env.NODE_ENV === "production" ? "" : ";label:WorksheetBody;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1dvcmtzaGVldEJvZHkudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWNTIiwiZmlsZSI6Ii4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1dvcmtzaGVldEJvZHkudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyoqIEBqc3gganN4ICovXG5cbmltcG9ydCB7IGNvbG9ycyB9IGZyb20gJ0BmbG93aW8vcmVhY3QtdGhlbWUnO1xuaW1wb3J0IHsgY3NzLCBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgeyBEaWFsb2dCb2R5IH0gZnJvbSAnQGZsb3dpby9yZWFjdC1kaWFsb2cnO1xuaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCB0eXBlIHsgRGlhbG9nQm9keVByb3BzIH0gZnJvbSAnQGZsb3dpby9yZWFjdC1kaWFsb2cnO1xuXG5jb25zdCBXb3Jrc2hlZXRCb2R5OiBSZWFjdC5GQzxEaWFsb2dCb2R5UHJvcHM+ID0gKHtcbiAgY2hpbGRyZW4sXG4gIC4uLnVuaGFuZGxlZFByb3BzXG59KSA9PiAoXG4gIDxEaWFsb2dCb2R5XG4gICAgey4uLnVuaGFuZGxlZFByb3BzfVxuICAgIGNzcz17Y3NzKHtcbiAgICAgIGJhY2tncm91bmRDb2xvcjogY29sb3JzLldISVRFLFxuICAgICAgcGFkZGluZzogJzEuNXJlbSAxcmVtJyxcbiAgICB9KX0+XG4gICAge2NoaWxkcmVufVxuICA8L0RpYWxvZ0JvZHk+XG4pO1xuXG5Xb3Jrc2hlZXRCb2R5LmRpc3BsYXlOYW1lID0gJ1dvcmtzaGVldEJvZHknO1xuXG5leHBvcnQgZGVmYXVsdCBXb3Jrc2hlZXRCb2R5O1xuIl19 */")
  }), children);
};

WorksheetBody.displayName = 'WorksheetBody';
export default WorksheetBody;